Ext.ns('mx.comp');

mx.comp.ListField = Ext.extend(Ext.form.Field, {
    defaultAutoCreate: {tag: 'input', type: 'hidden'},

    clsListValue: 'maxoptra-comp-list-value',
    valueFieldWidth: 0.5,

    valueFieldShift: 5,
    textFieldShift: 5,
    padding: 10,

    // used for rendering new elements
    adjustedValueFieldWidth: 100,
    adjustedTextFieldWidth: 100,
    allowBlank: true,
    blankText: 'This field is required',

    valueConfig: {},

    onGettingDirty: function() {
        // do nothing, override this to track list being changed by user
    },

    textConfig: {
        maxLength: mx.DEFAULT_MAX_LENGTH,
        enableKeyEvents: true,
    },

    buttonConfig: {
        icon: MXAT.commonsPath + 'img/delete-ins.gif',
        cls: 'x-btn-icon',
    },

    valueFieldName: 'value',

    // default value field - Ext.form.ComboBox
    valueFieldClass: Ext.form.ComboBox,

    textFieldName: 'text',

    // default text field - Ext.form.TextField
    textFieldClass: Ext.form.TextField,

    createValueField: function(config) {
        return new this.valueFieldClass(config);
    },

    createTextField: function(config) {
        return new this.textFieldClass(config);
    },

    initComponent: function() {
        // call parent initComponent
        mx.comp.ListField.superclass.initComponent.call(this);

        if (!this.value) {
            this.value = [];
        }
        this.value.push([null, null]); //empty field

        var value, valueField, textField, button;
        this.controls = new Ext.util.MixedCollection();
        for (var i = 0, length = this.value.length; i < length; i++) {
            value = this.value[i];
            // create value field
            valueField = this.createValueField(this.valueConfig);
            valueField.setValue(value[0]);
            valueField.ownerCt = this;

            // create text field
            textField = this.createTextField(this.textConfig);
            textField.setValue(value[1]);
            textField.ownerCt = this;

            valueField.on('change', this.changeVType.createDelegate(this, [valueField, textField]));
            // create button
            if (i == length - 1) {
                // the last button should be hidden
                button = new Ext.Button(Ext.apply({}, this.buttonConfig, {hidden: true}));
                // add handler to the last textfield
                //                textField.on('keypress', this.onKeyPress, this);
                valueField.on('change', this.onKeyPress, this);
            } else {
                button = new Ext.Button(this.buttonConfig);
            }
            button.ownerCt = this;

            this.controls.add([valueField, textField, button]);
        }
    },

    onRender: function(ct, position) {
        // don't run more than once
        if (this.isRendered) {
            return;
        }

        // render underlying hidden field
        mx.comp.ListField.superclass.onRender.call(this, ct, position);

        // create bounding table
        var t = Ext.DomHelper.append(
            ct,
            {
                tag: 'table',
                cls: 'maxoptra-comp-list-table',
                style: 'border-collapse:collapse;',
                children: [this.getRows(this.controls.getCount())],
                id: this.name + '_table',
            },
            true
        );

        this.tableEl = t;
        this.wrap = t.wrap();

        this.renderControls();

        // setup name for submit
        this.el.dom.name = this.hiddenName || this.name || this.id;

        // we're rendered flag
        this.isRendered = true;

        // update value
        this.updateHidden();
    },

    getRows: function(length) {
        var rows = [];
        for (var i = 0; i < length; i++) {
            rows.push({
                tag: 'tr',
                cls: 'maxoptra-comp-list-tr',
                children: [
                    {
                        tag: 'td',
                        cls: this.clsListValue,
                    },
                    {
                        tag: 'td',
                        cls: 'maxoptra-comp-list-text',
                        children: [
                            {
                                tag: 'div',
                                cls: 'maxoptra-comp-list-text-div',
                            },
                        ],
                    },
                    {
                        tag: 'td',
                        cls: 'maxoptra-comp-list-button',
                    },
                ],
            });
        }
        return rows;
    },

    onKeyPress: function(textField) {
        this.onGettingDirty();
        this.addEmptyRow();
        textField.un('change', this.onKeyPress, this);
    },

    addEmptyRow: function(updateHidden) {
        // create DOM tr element
        var tr = Ext.DomHelper.insertAfter(
            this.tableEl.child('tr:last-child.maxoptra-comp-list-tr'),
            {
                tag: 'tr',
                cls: 'maxoptra-comp-list-tr',
                style: 'visibility: hidden;',
                children: [
                    {
                        tag: 'td',
                        style: 'width: ' + this.adjustedValueFieldWidth + 'px;',
                        cls: this.clsListValue,
                    },
                    {
                        tag: 'td',
                        style: 'width: ' + this.adjustedTextFieldWidth + 'px;',
                        cls: 'maxoptra-comp-list-text',
                        children: [
                            {
                                tag: 'div',
                                cls: 'maxoptra-comp-list-text-div',
                            },
                        ],
                    },
                    {
                        tag: 'td',
                        cls: 'maxoptra-comp-list-button',
                    },
                ],
            },
            true
        );
        // create value field
        var valueField = this.createValueField(this.valueConfig);
        valueField.setValue(null);
        valueField.ownerCt = this;
        // create text field
        var textField = this.createTextField(this.textConfig);
        textField.setValue(null);
        textField.ownerCt = this;
        //        textField.on('keypress', this.onKeyPress, this);
        valueField.on('change', this.onKeyPress, this);
        // create button (hidden)
        var button = new Ext.Button(Ext.apply({}, this.buttonConfig, {hidden: true}));
        button.ownerCt = this;
        valueField.on('change', this.changeVType.createDelegate(this, [valueField, textField]));
        // create array of controls
        var ctrl = [valueField, textField, button];
        // render controls
        valueField.render(tr.child('td.' + this.clsListValue));
        valueField.setWidth(this.adjustedValueFieldWidth);

        textField.render(tr.child('div.maxoptra-comp-list-text-div'));
        textField.setWidth(this.adjustedTextFieldWidth);

        button.render(tr.child('td.maxoptra-comp-list-button'));
        // make tr visible (with animation)
        tr.setVisible(true, true);
        // prevent helper fields from being submitted
        valueField.el.dom.removeAttribute('name');
        textField.el.dom.removeAttribute('name');
        // add button handler
        button.on('click', this.removeRow.createDelegate(this, [tr, ctrl]));
        // show last button
        this.controls.last()[2].show();
        // add controls to the collection
        this.controls.add(ctrl);
        // update value
        if (updateHidden !== false) {
            this.updateHidden();
        }
    },

    addValue: function(value, text, updateHidden) {
        // create DOM tr element
        var tr = Ext.DomHelper.insertBefore(
            this.tableEl.child('tr:last-child.maxoptra-comp-list-tr'),
            {
                tag: 'tr',
                cls: 'maxoptra-comp-list-tr',
                children: [
                    {
                        tag: 'td',
                        style: 'width: ' + this.adjustedValueFieldWidth + 'px;',
                        cls: this.clsListValue,
                    },
                    {
                        tag: 'td',
                        style: 'width: ' + this.adjustedTextFieldWidth + 'px;',
                        cls: 'maxoptra-comp-list-text',
                        children: [
                            {
                                tag: 'div',
                                cls: 'maxoptra-comp-list-text-div',
                            },
                        ],
                    },
                    {
                        tag: 'td',
                        cls: 'maxoptra-comp-list-button',
                    },
                ],
            },
            true
        );
        // create value field
        var valueField = this.createValueField(this.valueConfig);
        if (valueField instanceof Ext.form.DateField) {
            value = new Date(value);
        }
        valueField.setValue(value);
        valueField.ownerCt = this;
        // create text field
        var textField = this.createTextField(this.textConfig);
        textField.setValue(text);
        textField.ownerCt = this;
        // create button
        var button = new Ext.Button(this.buttonConfig);
        button.ownerCt = this;
        // create array of controls
        var ctrl = [valueField, textField, button];
        // render controls
        valueField.render(tr.child('td.' + this.clsListValue));
        valueField.setWidth(this.adjustedValueFieldWidth);

        textField.render(tr.child('div.maxoptra-comp-list-text-div'));
        textField.setWidth(this.adjustedTextFieldWidth);

        button.render(tr.child('td.maxoptra-comp-list-button'));
        // prevent helper fields from being submitted
        valueField.el.dom.removeAttribute('name');
        textField.el.dom.removeAttribute('name');
        // add button handler
        button.on('click', this.removeRow.createDelegate(this, [tr, ctrl]));
        // add controls to the collection

        this.controls.insert(this.controls.getCount() - 1, ctrl);
        valueField.on('change', this.changeVType.createDelegate(this, [valueField, textField]));
        this.changeVType(valueField, textField);
        // update value
        if (updateHidden !== false) {
            this.updateHidden();
        }
    },

    changeVType: function(combobox, textfield) {
        if (combobox.getValue() && combobox.store) {
            var element = combobox.store.getAt(combobox.store.find('id', combobox.getValue()));
            if (element.get('vtype')) {
                textfield.vtype = element.get('vtype');
            } else {
                textfield.vtype = undefined;
            }
            if (element.get('regex')) {
                textfield.regex = element.get('regex');
            } else {
                textfield.regex = undefined;
            }
        }
    },

    removeRow: function(row, ctrl, updateHidden) {
        this.onGettingDirty();
        if (this.controls.remove(ctrl)) {
            // destroy controls
            for (var i = 0, length = ctrl.length; i < length; i++) {
                ctrl[i].destroy();
            }
            // remove DOM tr element
            row.remove();
            // update value
            if (updateHidden !== false) {
                this.updateHidden();
            }
        }
    },

    renderControls: function() {
        var row = this.tableEl.child('tr.maxoptra-comp-list-tr');
        for (var i = 0, length = this.controls.getCount(); i < length; i++) {
            var ctrl = this.controls.itemAt(i);
            ctrl[0].render(row.child('td.' + this.clsListValue));
            ctrl[1].render(row.child('div.maxoptra-comp-list-text-div'));
            ctrl[2].render(row.child('td.maxoptra-comp-list-button'));

            // prevent helper fields from being submitted
            ctrl[0].el.dom.removeAttribute('name');
            ctrl[1].el.dom.removeAttribute('name');
            // add button handler
            ctrl[2].on('click', this.removeRow.createDelegate(this, [row, ctrl]));
            row = row.next('tr.maxoptra-comp-list-tr');
        }
    },

    adjustSize: function(w, h) {
        if (typeof w == 'number') {
            if (!Ext.isSafari) {
                if (Ext.isIE) {
                    if (!Ext.isStrict) {
                        w -= 3;
                    } else {
                        w -= Ext.isIE6 ? 4 : 1;
                    }
                } else if (Ext.isOpera && Ext.isStrict) {
                    w += 2;
                }
            }
        }
        return {width: w, height: h};
    },

    onResize: function(w, h) {
        if (!w) {
            return;
        }
        var padding = this.padding;
        var buttonWidth = 24;
        var restWidth = w - buttonWidth - padding;
        var valueFieldWidth, textFieldWidth;
        if (this.valueFieldWidth < 1) {
            valueFieldWidth = Math.round(restWidth * this.valueFieldWidth);
        } else {
            valueFieldWidth = this.valueFieldWidth;
        }
        textFieldWidth = restWidth - valueFieldWidth;
        this.controls.each(function(ctrl) {
            ctrl[0].setWidth(valueFieldWidth);
            ctrl[0]
                .getEl()
                .parent('td.' + this.clsListValue)
                .setWidth(valueFieldWidth + this.valueFieldShift);
            ctrl[1].setWidth(textFieldWidth);
            ctrl[1]
                .getEl()
                .parent('td.maxoptra-comp-list-text')
                .setWidth(textFieldWidth + this.textFieldShift);
        }, this);
        this.adjustedValueFieldWidth = valueFieldWidth;
        this.adjustedTextFieldWidth = textFieldWidth;
    },

    beforeDestroy: function() {
        if (this.isRendered) {
            this.wrap.removeAllListeners();
            this.wrap.remove();
            this.tableEl.remove();
            this.controls.each(function(ctrl) {
                ctrl[0].destroy();
                ctrl[1].destroy();
                ctrl[2].destroy();
            });
            this.controls.clear();
        }
    },

    disable: function() {
        if (this.isRendered) {
            this.controls.each(function(ctrl) {
                ctrl[0].onDisable();
                ctrl[1].onDisable();
                ctrl[2].onDisable();
            });
        }
        this.disabled = true;
        this.fireEvent('disable', this);
        return this;
    },

    enable: function() {
        if (this.rendered) {
            this.controls.each(function(ctrl) {
                ctrl[0].onEnable();
                ctrl[1].onEnable();
                ctrl[2].onEnable();
            });
        }
        this.disabled = false;
        this.fireEvent('enable', this);
        return this;
    },

    getValue: function() {
        var value = [],
            ctrl,
            data;
        for (var i = 0, length = this.controls.getCount() - 1; i < length; i++) {
            ctrl = this.controls.itemAt(i);
            data = new Object();
            data[this.valueFieldName] = ctrl[0].getValue();
            data[this.textFieldName] = ctrl[1].getValue();
            value.push(new mx.data.ListFieldRecord(data));
        }
        return value;
    },

    getHiddenValue: function() {
        return this.el.dom.value;
    },

    updateHidden: function() {
        if (this.isRendered) {
            this.el.dom.value = this.getValue();
        }
    },

    clear: function() {
        var row, ctrl;
        for (var i = 0, length = this.controls.getCount() - 1; i < length; i++) {
            row = this.tableEl.child('tr.maxoptra-comp-list-tr');
            ctrl = this.controls.first(0);
            this.removeRow(row, ctrl, false);
        }
        this.updateHidden();
    },

    initValue: Ext.emptyFn,

    setValue: function(value) {
        if (Ext.isArray(value)) {
            this.clear();
            var v,
                length = value.length;
            this.tableEl.hide();
            for (var i = 0; i < length; i++) {
                v = value[i];
                this.addValue(v.get(this.valueFieldName), v.get(this.textFieldName), false);
            }
            this.updateHidden();
            this.tableEl.show(true);
        }
    },

    validateValue: function() {
        var res = true;
        if (!this.allowBlank) {
            var tmpField = this.controls.itemAt(0);
            if (this.controls.getCount() == 1 && !tmpField[2].isVisible()) {
                tmpField[0].markInvalid(this.blankText);
                tmpField[1].markInvalid(this.blankText);
                res = false;
            }
        }
        for (var i = 0, length = this.controls.getCount(); i < length; i++) {
            var ctrl = this.controls.itemAt(i);
            if (i == length - 1 && !ctrl[0].getValue() && !ctrl[1].getValue()) {
                continue;
            }
            res = this._checkControls(ctrl);
        }
        return res;
    },

    _checkControls: function(ctrl) {
        var res = true;
        if (!ctrl[0].getValue()) {
            ctrl[0].markInvalid();
            res = false;
        }
        if (res && !ctrl[1].getValue()) {
            ctrl[1].markInvalid();
            res = false;
        }
        if (res && !ctrl[1].validateValue(ctrl[1].getValue())) {
            res = false;
        }
        return res;
    },
});

Ext.reg('mx_list', mx.comp.ListField);
